import { applyTokens, colorKeys } from "../../../utilities/applyTokens.js";
export const getButtonTokens = (tokens) => {
    return {
        button: tokens.component.button,
        semantic: tokens.semantic,
        loadingIndicator: tokens.component.loadingIndicator,
    };
};
const squeezePadding = (width = "0", originalPadding = "0") => `0 calc(${originalPadding} - ${width})`;
const setIconColor = (tokens) => tokens
    ? {
        "& > svg, & .MuiButton-startIcon, & .MuiButton-endIcon": applyTokens(tokens, colorKeys),
    }
    : {};
export const getIconOffsets = (size, tokens) => (Object.assign(Object.assign(Object.assign({}, (size === "large" && {
    marginLeft: "0",
    marginRight: "0",
})), (size === "medium" && {
    marginLeft: `-${tokens.semantic.spacing.default.value}`,
    marginRight: `-${tokens.semantic.spacing.default.value}`,
})), (size === "small" && {
    marginLeft: `-${tokens.semantic.spacing.md.value}`,
    marginRight: `-${tokens.semantic.spacing.md.value}`,
})));
export const createAtlasButtonVariant = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
buttonType, tokens) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { button } = getButtonTokens(tokens);
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, applyTokens(buttonType.default, colorKeys)), setIconColor(buttonType.default.icon)), { borderWidth: ((_a = buttonType.default.borderWidth) === null || _a === void 0 ? void 0 : _a.value) || 0, borderStyle: "solid" }), (buttonType.hover && {
        "&:hover": Object.assign(Object.assign(Object.assign({}, applyTokens(buttonType.hover, colorKeys)), setIconColor(buttonType.hover.icon)), { borderWidth: ((_b = buttonType.hover.borderWidth) === null || _b === void 0 ? void 0 : _b.value) || ((_c = buttonType.default.borderWidth) === null || _c === void 0 ? void 0 : _c.value) || 0, 
            // In order to support changing border widths between states,
            // we subtract the difference in border widths from the horizontal padding.
            // Button height is always fix, so vertical padding doesn't need to change.
            padding: squeezePadding((_d = buttonType.hover.borderWidth) === null || _d === void 0 ? void 0 : _d.value, button.paddingHorizontal.value) }),
    })), (buttonType.active && {
        "&:active": Object.assign(Object.assign(Object.assign({}, applyTokens(buttonType.active, colorKeys)), setIconColor(buttonType.active.icon)), { borderWidth: ((_e = buttonType.active.borderWidth) === null || _e === void 0 ? void 0 : _e.value) || ((_f = buttonType.default.borderWidth) === null || _f === void 0 ? void 0 : _f.value) || 0, padding: squeezePadding((_g = buttonType.active.borderWidth) === null || _g === void 0 ? void 0 : _g.value, button.paddingHorizontal.value) }),
    })), (buttonType.disabled && {
        "&.Mui-disabled": Object.assign(Object.assign({}, applyTokens(buttonType.disabled, colorKeys)), setIconColor(buttonType.disabled.icon)),
    }));
};
//# sourceMappingURL=createAtlasButtonVariant.js.map